import React from 'react';
import { withAuth } from '@okta/okta-react';
import { withAlert } from 'react-alert';
import { Alert, Col, Row } from 'reactstrap';
import Api from '../../Api';
import HtmlHelpers from '../../HtmlHelpers';
import CrudForm from '../../Crud/Form';
export default withAuth(withAlert()(class AddForm extends CrudForm {
  constructor() {
    super(...arguments);
    this.formType = () => this.props.title;
    this.getCrudType = () => 'attachments';
    this.getLabelColumns = () => 3;
    this.getFieldColumns = () => 7;
    this.successAlertMsg = data => ['Attachment added successfully', 'success'];
    this.onSubmit = event => this.formDataSubmit(event);
    this.modalBodyRows = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: this.getLabelColumns()
    }), /*#__PURE__*/React.createElement(Col, {
      md: this.getFieldColumns(),
      xs: "12",
      className: "text-center"
    }, /*#__PURE__*/React.createElement(Alert, {
      color: "warning"
    }, "Attachments cannot contain sensitive information"))), this.getTextFieldRow('name', 'Name', true), this.getTextareaRow('description', 'Description', false), this.getUploadFileRow('attachment', ''), /*#__PURE__*/React.createElement("br", null));
    this.onChangeFileEvent = async event => {
      const newData = Object.assign({}, this.state.item);
      const target = event.target;
      newData[target.name] = target.files[0];
      return newData;
    };
    this.formData = () => {
      const form = new FormData();
      form.append('name', this.state.item.name || '');
      form.append('description', this.state.item.description || '');
      if (this.state.item.attachment !== undefined) {
        form.append('attachment', this.state.item.attachment);
      }
      form.append('model_uuid', this.props.modelUuid);
      form.append('model_type', this.props.modelType);
      return form;
    };
  }
}));